'use client';

import { useRouter, useSearchParams } from 'next/navigation';

export const useRedirectBasedOnRefQueryParam = () => {
  const router = useRouter();

  const searchParams = useSearchParams();

  return {
    redirectBasedOnRefQueryParam: () => {
      const comingFrom = searchParams?.get('ref');

      if (comingFrom === 'portfolio') {
        router.push('/portfolio');
      } else if (comingFrom === 'prices') {
        const appliedFilter = searchParams?.get('assetType');

        if (appliedFilter) {
          router.push(`/discover?assetType=${appliedFilter}`);
        } else {
          router.push('/discover');
        }
      } else {
        router.back();
      }
    },
  };
};
